import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Toast,
  Userlogin,
  ownerDrop,
  DateFormate,
  customStyles,
  PushpoptoCatalogue,
  priceTagCmn,
} from "./Utils/general-function";
import Header from "./Header";
import Loader from "./Utils/Loader";
import Select from "react-select";
import styled from "styled-components";

export function Test(props) {
  const [loading, setLoading] = useState(true);
  const [Companylist, setCompanylist] = useState([]);
  const [Brandlist, setBrandlist] = useState([]);
  const [Varientlist, setVarientlist] = useState([]);
  const [Countries, setCountries] = useState([]);
  const [States, setStates] = useState([]);
  const [Cities, setCities] = useState([]);
  const [Gearlist, setGearlist] = useState([]);

  const [Fuelist, setFuelist] = useState([
    "Petrol",
    "Diesel",
    "CNG",
    "Electric",
    "Hybrid",
  ]);
  const [input, setInput] = useState({
    company: "",
    Model: "",
    varient: "",
    fuel: "",
    carData: {},
    Country: "",
    State: "",
    City: "",
    gear: "",
  });

  const called = useRef(false);

  async function testShareDemo() {
    if (
      !input.company ||
      !input.Model ||
      !input.varient ||
      !input.fuel ||
      !input?.gear ||
      !input?.State ||
      !input?.City
    ) {
      Toast(false, "", "Please fill all fields");
      return;
    }
    setLoading(true);

    let comp = Companylist.find((c) => c.Value === input.company)?.Text || "";
    let mod = Brandlist.find((m) => m.Value === input.Model.Value)?.Text || "";
    let varnt = Varientlist.find((v) => v.Value === input.varient)?.Text || "";
    let gear = Gearlist.find((v) => v.Value === input?.gear)?.Text || "";
    let state = States.find((v) => v.Value === input?.State)?.Text || "";
    let city = Cities.find((v) => v.Value === input?.State)?.Text || "";

    const raw = JSON.stringify({
      contents: [
        {
          parts: [
            {
              //             text: `You are a vehicle pricing API.
              //   Search the web for latest official information before answering.
              // Return ONLY valid JSON.

              // Car details:
              // Brand: Tata
              // Model: Sierra
              // Variant: Smart+
              // State: Gujarat
              // City: Ahmedabad

              // Fields:
              // brand
              // model
              // variant
              // ex_showroom_price
              // engine_cc
              // fuel
              // transmission
              // mileage

              // Rules:
              // - ex_showroom_price must be a number in INR.
              // - No currency symbol.
              // - No commas.
              // - If unsure return null.
              // `,

              text: `You are a vehicle pricing API.

Search the web for the latest official information before answering.

Use trusted automotive sources such as:
CarDekho
ZigWheels
CarTrade
Autocar India

Return ONLY valid JSON.

Car details:
Brand: ${comp}
Model: ${mod}
Variant: ${varnt}
Fuel: ${input.fuel}
Gear: ${gear}
State: ${state}
City: ${city}

Fields required:
brand
model
variant
engine_cc
fuel
transmission
mileage
ex_showroom_price
on_road_price
lowest_price


Rules:
1. Use the exact variant if available.
2. If the exact variant is unavailable, choose the closest matching variant.
3. Prices must be numbers only in INR (no ₹ symbol, no commas).
4. On-road price must be estimated for the given city and state.
5. Use the most recent 2025–2026 pricing data.
6. Do not guess values. If data is unavailable return null.
7. Return strictly valid JSON with no explanation or extra text.

JSON format:

{
"brand": "",
"model": "",
"variant": "",
"engine_cc": 0,
"fuel": "",
"transmission": "",
"mileage": "",
"ex_showroom_price": 0,
"on_road_price": 0,
"lowest_price": 0,
"latest_price": 0
}`,
            },
          ],
        },
      ],

      // tools: [
      //   {
      //     google_search: {},
      //   },
      // ],

      // generationConfig: {
      //   temperature: 0,
      //   response_mime_type: "application/json",
      // },
    });
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-goog-api-key": "AIzaSyAshY9-WrfY0d5tsavdHOi8AkI93Oi1Qg4",
      },
      body: raw,
      redirect: "follow",
    };
    //https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-lite:generateContent?key=AIzaSyAshY9-WrfY0d5tsavdHOi8AkI93Oi1Qg4

    //https://generativelanguage.googleapis.com/v1beta/models/gemini-flash-latest:generateContent
    fetch(
      "https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-lite:generateContent?key=AIzaSyBGLWR5kTSKw_rvmRbneJPXvqwl9DPTpEo",
      requestOptions,
    )
      .then((response) => {
        if (response.status === 429) {
          Toast(false, "", "Too many requests.");
        }

        return response.json();
      })
      .then((result) => {
        let text = result.candidates[0].content.parts[0].text;
        console.log("text", text);

        // remove markdown ```json ```
        text = text.replace(/```json|```/g, "").trim();

        const carData = JSON.parse(text);

        console.log(carData);
        setInput((prev) => ({
          ...prev,
          carData: carData || {},
        }));
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);

        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  //   async function testShareDemo() {
  //     //     const raw = JSON.stringify({
  //     //       contents: [
  //     //         {

  //     if (!input.company || !input.Model || !input.varient || !input.fuel) {
  //       Toast(false, "", "Please fill all fields");
  //       return;
  //     }
  //     setLoading(true);

  //     let comp = Companylist.find((c) => c.Value === input.company)?.Text || "";
  //     let mod = Brandlist.find((m) => m.Value === input.Model.Value)?.Text || "";
  //     let varnt = Varientlist.find((v) => v.Value === input.varient)?.Text || "";

  //     const raw = JSON.stringify({
  //       messages: [
  //         {
  //           role: "system",
  //           content: "You are a vehicle pricing API.",
  //         },
  //         {
  //           role: "user",
  //           content: `Use verified automotive sources such as manufacturer websites, CarDekho, ZigWheels, or HT Auto. Return JSON only.

  //   Car details:
  //   // Brand: ${comp}
  //   // Model: ${mod}
  //   // Variant: ${varnt}
  //   // fuel: ${input.fuel}
  //   // State: Gujarat
  //   // City: Ahmedabad
  //   Brand: kia
  //   Model: carens
  //   Variant: DSL
  //   Gear: mt
  //   fuel: ${input.fuel}
  //   State: Gujarat
  //   City: Ahmedabad

  //   Fields:
  //   brand
  //   model
  //   variant
  //   ex_showroom_price
  //   engine_cc
  //   fuel
  //   transmission
  //   mileage
  //   on_road_price
  //   lowest_price
  //   latest_price

  //   Rules:
  // - ex_showroom_price must be a string.
  // - Format must be Indian Rupees (₹) with Indian comma style.
  // - Example: ₹7,49,000 or ₹21,98,000.
  // - Do not return plain numbers.
  // - If 100% unsure return Not Available.
  //   // - No currency symbol.
  //   // - No commas.
  //   `,
  //         },
  //       ],
  //       model: "llama-3.3-70b-versatile",
  //     });
  //     const requestOptions = {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization:
  //           "Bearer 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",
  //       },
  //       body: raw,
  //       redirect: "follow",
  //     };

  //     fetch("https://api.groq.com/openai/v1/chat/completions", requestOptions)
  //       .then((response) => response.json())
  //       .then((result) => {
  //         let text = result.choices[0].message.content
  //           .replace(/```json|```/g, "")
  //           .trim();

  //         const carData = JSON.parse(text);
  //         console.log("carData", carData);

  //         setInput((prevInput) => ({
  //           ...prevInput,
  //           carData: carData || {},
  //         }));

  //         setLoading(false);
  //       })
  //       .catch((error) => {
  //         setLoading(false);

  //         console.error(error);
  //       });
  //   }

  const handleCompanychange = (obj) => {
    fetch(
      process.env.REACT_APP_API_ENDPOINT +
        "/api/Common/activemodel/" +
        obj.Value,
    )
      .then((response) => response.json())
      .then((res) => {
        setBrandlist(res.Data || []);
        setVarientlist([]);

        setInput((prevInput) => ({
          ...prevInput,
          company: obj.Value,
          Model: "",
          varient: "",
        }));
      });
  };

  const handleModalchange = (obj) => {
    var details =
      "companyid=" +
      encodeURIComponent(input.company) +
      "&Modelid=" +
      encodeURIComponent(obj.Value);
    const requestOptions = {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
      body: details,
    };
    fetch(
      process.env.REACT_APP_API_ENDPOINT + "/api/Common/veriantandcolour",
      requestOptions,
    )
      .then((response) => response.json())
      .then((res) => {
        setVarientlist(res.Data.veriantdata || []);

        setInput((prevInput) => ({
          ...prevInput,
          Model: obj,
          varient: "",
        }));
      });
  };

  const handlevarient = (obj) => {
    setInput((prevInput) => ({
      ...prevInput,
      varient: obj.Value,
      color: "",
    }));
  };
  useEffect(() => {
    if (called.current) return;
    called.current = true;

    if (Userlogin()) {
      fetch(process.env.REACT_APP_API_ENDPOINT + "/api/Common/companydata")
        .then((response) => response.json())
        .then((res) => {
          setCompanylist(res.Data);
        });
      fetch(process.env.REACT_APP_API_ENDPOINT + "/api/Common/Geardata")
        .then((response) => response.json())
        .then((res) => {
          setGearlist(res.Data);
        });
      fetch(
        process.env.REACT_APP_API_ENDPOINT +
          "/api/Common/statenamedata?countryid=1",
      )
        .then((response) => response.json())
        .then((res) => {
          setStates(res.Data || []);
        });
    }
    setLoading(false);
  }, []);

  const handleChange = (e) => {
    let value = e.target.value;
    setInput((prevInput) => ({
      ...prevInput,
      [e.target.name]: value,
    }));
  };
  const fetchcitiesbystate = (state) => {
    fetch(
      process.env.REACT_APP_API_ENDPOINT +
        "/api/Common/citynamedata?countryid=1" +
        "&stateid=" +
        state,
    )
      .then((response) => response.json())
      .then((res) => {
        setCities(res.Data || []);
        setLoading(false);
      });
  };

  const fetchstate = () => {
    setLoading(true);
    fetch(
      process.env.REACT_APP_API_ENDPOINT +
        "/api/Common/statenamedata?countryid=1",
    )
      .then((response) => response.json())
      .then((res) => {
        setStates(res.Data || []);
        setLoading(false);
      });
  };

  useEffect(() => {
    const header = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
      },
    };
    try {
      fetch(process.env.REACT_APP_API_ENDPOINT + "/api/Common/countrydata")
        .then((response) => response.json())
        .then((res) => {
          setCountries(res.Data);
          // if (res.Data[0].nCountry) {
          //   fetchstate(res.Data[0].nCountry);
          //   fetchcitiesbystate(res.Data[0].nCountry, res.Data[0].nState);
          // }
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }, []);

  const handlestatechange = (e) => {
    setLoading(true);
    setInput((prevInput) => ({
      ...prevInput,
      [e.target.name]: e.target.value,
      City: "",
    }));
    fetchcitiesbystate(e.target.value);
  };
  const OnCountryChange = (e) => {
    const value = e.target.value;
    setInput((prevInput) => ({
      ...prevInput,
      [e.target.name]: value,
      State: "",
      City: "",
    }));
    fetchstate(value);
  };

  function formatIndianPrice(amount) {
    if (amount >= 10000000) {
      return "₹" + (amount / 10000000).toFixed(2) + " Crore";
    } else if (amount >= 100000) {
      return "₹" + (amount / 100000).toFixed(2) + " Lakh";
    } else {
      return "₹" + new Intl.NumberFormat("en-IN").format(amount);
    }
  }

  console.log(formatIndianPrice(12330000));

  const isMobile = window.innerWidth < 480;
  return (
    <div>
      {loading && <Loader />}
      <Header />
      <div className="content">
        <div className="text-center">
          <h2 className="page-title">Ex-Showroom Price - Ai</h2>
        </div>
        <div className="form-div">
          <label className="form-label">Company</label>
          <Select
            placeholder="--Select Company--"
            name="company"
            options={Companylist}
            value={Companylist.find((c) => c.Value === input.company) || null}
            getOptionLabel={(option) => option.Text}
            getOptionValue={(option) => option.Value}
            onChange={(e) => {
              handleCompanychange(e);
              // console.log("reacat  sele", e);
            }}
            closeMenuOnSelect={true}
            blurInputOnSelect={false}
            isSearchable={true}
            styles={customStyles}
          ></Select>

          {/* <span className="text-danger">{errors.company}</span> */}
        </div>

        <div className="form-div">
          <label className="form-label">Model</label>
          <Select
            placeholder="--Select Model--"
            value={input.Model}
            name="Model"
            options={Brandlist}
            getOptionLabel={(option) => option.Text}
            getOptionValue={(option) => option.Value}
            onChange={(e) => {
              handleModalchange(e);
              // console.log("reacat  sele", e);
            }}
            closeMenuOnSelect={true}
            blurInputOnSelect={false}
            isSearchable={true}
            styles={customStyles}
          ></Select>
          {/* <span className="text-danger">{errors.Model}</span> */}
        </div>

        <div className="form-div">
          <label className="form-label">Varient</label>
          <Select
            placeholder="--Select Varient--"
            name="varient"
            value={Varientlist.find((v) => v.Value === input.varient) || null}
            options={Varientlist}
            getOptionLabel={(option) => option.Text}
            getOptionValue={(option) => option.Value}
            onChange={(e) => {
              handlevarient(e);
              // console.log("reacat  sele", e);
            }}
            closeMenuOnSelect={true}
            blurInputOnSelect={false}
            isSearchable={true}
            styles={customStyles}
          ></Select>
          {/* <span className="text-danger">{errors.varient}</span> */}
        </div>
        <div className="form-div">
          <label className="form-label">Fuel</label>
          <select
            className="form-select form-control"
            name="fuel"
            value={input.fuel}
            defaultValue=""
            onChange={(e) => {
              handleChange(e);
              // console.log("reacat  sele", e);
            }}
          >
            <option value="" disable="disable">
              --Select Fuel--
            </option>
            {Fuelist.map((list, i) => (
              <option value={list} key={i}>
                {list}
              </option>
            ))}
          </select>

          {/* <span className="text-danger">{errors.fuel}</span> */}
        </div>

        <div className="form-div">
          <label className="form-label">Gear</label>
          <select
            className="form-select form-control"
            name="gear"
            defaultValue=""
            onChange={(e) => {
              handleChange(e);
              // console.log("reacat  sele", e);
            }}
          >
            <option value="" disable="disable">
              --Select Gear--
            </option>
            {Gearlist.map((list) => (
              <option value={list.Value} key={list.Value}>
                {list.Text}
              </option>
            ))}
          </select>

          {/* <span className="text-danger">{errors.gear}</span> */}
        </div>
        {/* <div className="form-div">
          <label className="form-label">Select Country</label>
          <select
            className="form-select form-control"
            name="Country"
            value={input.Country}
            onChange={OnCountryChange}
          >
            <option value="" disabled={true}>
              -- Select Country --
            </option>
            {Countries.map((list, i) => (
              <option value={list.Value} key={i}>
                {list.Text}
              </option>
            ))}
          </select>
          <span className="text-danger">{errors.Country}</span>
        </div> */}
        <div className="form-div">
          <label className="form-label">Select State</label>
          <select
            className="form-select form-control"
            name="State"
            value={input.State}
            onChange={handlestatechange}
          >
            <option value="" disabled={true}>
              -- Select State --
            </option>

            {States.map((list) => (
              <option value={list.Value} key={list.Text}>
                {list.Text}
              </option>
            ))}
          </select>
          {/* <span className="text-danger">{errors.State}</span> */}
        </div>
        <div className="form-div">
          <label className="form-label">Select City</label>
          <div className="d-flex flex-nowrap">
            <select
              className="form-select form-control"
              name="City"
              onChange={handleChange}
              value={input.City}
              // disabled={iscitydisabled}
            >
              <option value="" disabled="disabled">
                -- Select City --
              </option>
              {Cities.map((list) => (
                <option value={list.Value} key={list.Text}>
                  {list.Text}
                </option>
              ))}
            </select>
          </div>
          {/* <span className="text-danger">{errors.City}</span> */}
        </div>
        <div className="text-center pt-3">
          <button type="submit" className="submitbtn" onClick={testShareDemo}>
            Submit
          </button>
        </div>
      </div>

      {Object.keys(input.carData).length > 0 && (
        <div
          style={{
            background: "#ffffff",
            borderRadius: "16px",
            padding: isMobile ? "16px" : "22px",
            boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
            border: "1px solid #eee",
            fontFamily: "Segoe UI, sans-serif",
            marginBottom: "30px",
          }}
        >
          {/* Brand */}
          <div
            style={{
              color: "#e60023",
              fontWeight: "700",
              fontSize: "14px",
              letterSpacing: "1px",
            }}
          >
            {input.carData.brand}
          </div>

          {/* Model */}
          <div
            style={{
              fontSize: isMobile ? "22px" : "26px",
              fontWeight: "700",
              marginTop: "2px",
              color: "#111",
            }}
          >
            {input.carData.model}
          </div>

          {/* Variant */}
          <div
            style={{
              fontSize: "13px",
              color: "#777",
              marginBottom: "16px",
            }}
          >
            {input.carData.variant}
          </div>

          {/* Price Section */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr 1fr",
              gap: "10px",
              marginBottom: "18px",
            }}
          >
            {/* Ex Showroom */}
            <div
              style={{
                background: "#fafafa",
                borderRadius: "12px",
                padding: "12px",
                borderLeft: "4px solid #e60023",
              }}
            >
              <div style={{ fontSize: "11px", color: "#888" }}>Ex-Showroom</div>
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "#e60023",
                }}
              >
                {formatIndianPrice(input.carData.ex_showroom_price || 0)}
              </div>
            </div>

            {/* On Road */}
            <div
              style={{
                background: "#fafafa",
                borderRadius: "12px",
                padding: "12px",
                borderLeft: "4px solid #2a7de1",
              }}
            >
              <div style={{ fontSize: "11px", color: "#888" }}>On-Road</div>
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "#2a7de1",
                }}
              >
                {formatIndianPrice(input.carData.on_road_price || 0)}
              </div>
            </div>

            {/* Lowest */}
            <div
              style={{
                background: "#fafafa",
                borderRadius: "12px",
                padding: "12px",
                borderLeft: "4px solid #2ab673",
              }}
            >
              <div style={{ fontSize: "11px", color: "#888" }}>
                Lowest Market
              </div>
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "#2ab673",
                }}
              >
                {formatIndianPrice(input.carData.lowest_price || 0)}
              </div>
            </div>
          </div>

          {/* Specs */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "14px",
              fontSize: "14px",
            }}
          >
            <div>
              <div style={{ color: "#888", fontSize: "12px" }}>Fuel</div>
              <div style={{ fontWeight: "600" }}>{input.carData.fuel}</div>
            </div>

            <div>
              <div style={{ color: "#888", fontSize: "12px" }}>
                Transmission
              </div>
              <div style={{ fontWeight: "600" }}>
                {input.carData.transmission}
              </div>
            </div>

            <div>
              <div style={{ color: "#888", fontSize: "12px" }}>Engine</div>
              <div style={{ fontWeight: "600" }}>
                {input.carData.engine_cc} cc
              </div>
            </div>

            <div>
              <div style={{ color: "#888", fontSize: "12px" }}>Mileage</div>
              <div style={{ fontWeight: "600" }}>{input.carData.mileage}</div>
            </div>
          </div>

          {/* Disclaimer */}
          <div
            style={{
              fontSize: "12px",
              color: "#777",
              textAlign: "center",
              marginTop: "12px",
              lineHeight: "1.5",
            }}
          >
            This price is an AI-generated estimate and may differ from the
            official price. Please confirm with an authorized dealership.
          </div>
        </div>
      )}
      {/* {Object.keys(input.carData).length > 0 && (
        <div
          style={{
            background: "#ffffff",
            borderRadius: "16px",
            padding: "22px",
            boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
            border: "1px solid #eee",
            fontFamily: "Segoe UI, sans-serif",
            marginBottom: "30px",
          }}
        >
          <div
            style={{
              color: "#e60023",
              fontWeight: "700",
              fontSize: "15px",
              letterSpacing: "1px",
            }}
          >
            {input.carData.brand}
          </div>

          <div
            style={{
              fontSize: "26px",
              fontWeight: "700",
              marginTop: "2px",
              color: "#111",
            }}
          >
            {input.carData.model}
          </div>

          <div
            style={{
              fontSize: "13px",
              color: "#777",
              marginBottom: "16px",
            }}
          >
            {input.carData.variant}
          </div>

          <div
            style={{
              background: "#fafafa",
              borderRadius: "12px",
              padding: "14px",
              marginBottom: "18px",
              borderLeft: "4px solid #e60023",
            }}
          >
            <div style={{ fontSize: "12px", color: "#888" }}>
              Ex-Showroom Price
            </div>

            <div
              style={{
                fontSize: "24px",
                fontWeight: "700",
                color: "#e60023",
              }}
            >
              {input.carData.ex_showroom_price}
            </div>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "14px",
              fontSize: "14px",
            }}
          >
            <div>
              <div style={{ color: "#888", fontSize: "12px" }}>Fuel</div>
              <div style={{ fontWeight: "600" }}>{input.carData.fuel}</div>
            </div>

            <div>
              <div style={{ color: "#888", fontSize: "12px" }}>
                Transmission
              </div>
              <div style={{ fontWeight: "600" }}>
                {input.carData.transmission}
              </div>
            </div>

            <div>
              <div style={{ color: "#888", fontSize: "12px" }}>Engine</div>
              <div style={{ fontWeight: "600" }}>
                {input.carData.engine_cc} cc
              </div>
            </div>

            <div>
              <div style={{ color: "#888", fontSize: "12px" }}>Mileage</div>
              <div style={{ fontWeight: "600" }}>{input.carData.mileage}</div>
            </div>
          </div>
          <div
            style={{
              fontSize: "12px",
              color: "#777",
              textAlign: "center",
              marginTop: "10px",
              lineHeight: "1.5",
            }}
          >
            This price is an AI-generated estimate and may differ from the
            official ex-showroom price. Please confirm with an authorized
            dealership.
          </div>
        </div>
      )} */}
    </div>
  );
}
